import { CoreCheckbox } from '@komodo-design-system/komodo-components-react';
import React from 'react';
import './SingleUploadContent.scss';
import { MetadataElement, MetadataElementList } from './SingleUploadModel';
import { useDispatch, useSelector } from 'react-redux';
import { singleUploadActions } from 'actions/singleUpload';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { PRODUCT_IDENITFIER_MAP } from 'constants/constants';
import { SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS } from 'constants/actionTypes';

interface CheckboxWrapperProps {
  element: any; // Replace 'any' with the specific type if known
  rowIndex: number | null | undefined; // Added rowIndex prop
}

const CheckboxWrapper: React.FC<CheckboxWrapperProps> = ({
  element,
  rowIndex
}) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const singleUploadPayload = useSelector(
    (state: any) => state.singleUpload.payload
  );
  // Utility function to update the Redux store
  const updateReduxStore = (updatedPayload: MetadataElementList[]) => {
    const updatedSingleUploadPayload = {
      ...singleUploadPayload,
      metadata_collection: {
        ...singleUploadPayload.metadata_collection,
        metadata_element_list: updatedPayload
      }
    };
    dispatch(
      singleUploadActions.updateSingleUploadPayload(updatedSingleUploadPayload)
    );
  };
  const getValues = (
    previousValues: any,
    selectedProducts: any,
    mappingId: keyof typeof PRODUCT_IDENITFIER_MAP
  ) => {
    const id = PRODUCT_IDENITFIER_MAP[mappingId];
    const values = selectedProducts.map((product: any) => { 
      return {
        id:id==='isCustom' ? product.isCustom : "",
        display_value:id==='isCustom' ? product.isCustom : ""
      };
    });
    previousValues[rowIndex || 0] = values[0];
    return [...previousValues, ...values.slice(1)];
  };

  const updateProductIdentifiers = (selectedProducts: any) => {
    // Update the Redux store with the selected products
    const currentState = { ...singleUploadPayload };
    const result = currentState?.metadata_collection?.metadata_element_list
      ?.find((obj: any) => obj.id === 'TFS.CATEGORY.PRODUCT_IDENTIFIERS')
      .metadata_element_list.map((field: any) => {
        field.values = getValues(
          field.values,
          selectedProducts,
          field.field_id
        );
        return field;
      });
    const updatedPayload = {
      ...singleUploadPayload,
      metadata_collection: {
        ...singleUploadPayload.metadata_collection,
        metadata_element_list: singleUploadPayload?.metadata_collection?.metadata_element_list.map(
          (obj: any) => {
            if (obj.id === 'TFS.CATEGORY.PRODUCT_IDENTIFIERS') {
              return {
                ...obj,
                metadata_element_list: result
              };
            }
            return obj;
          }
        )
      }
    };
    // Dispatch the updated payload to the Redux store
    dispatch({
      type: SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS,
      payload: updatedPayload
    });
  };

  const clearRow = (
    mappingId: keyof typeof PRODUCT_IDENITFIER_MAP,
    action: string
  ) => {
    const selectedProducts = [
      {
        description: '',
        erp: '',
        fcatNum: '',
        gid: '',
        labelCode: '',
        mpn: '',
        productName: '',
        productTitle: '',
        rootSku: '',
        targetSite: '',
        vendorName: '',
        vnum: '',
        webId: '',
        isCustom: action === 'YES' ? 'Y' : 'N'
      }
    ];
    updateProductIdentifiers(selectedProducts);
  };

  // Handle text field changes
  const onCheckboxChange = (value: boolean) => {
    if (element.field_id === 'TFS.FIELD.IS_CUSTOM') {
      // Handle the custom checkbox logic
      const mappingId = element.mapping_id as keyof typeof PRODUCT_IDENITFIER_MAP;
      if (value) {
        clearRow(mappingId, 'YES');
      } else {
        clearRow(mappingId, 'NO');
      }
      return;
    }
    const updatedPayload = singleUploadPayload?.metadata_collection?.metadata_element_list?.map(
      (el: MetadataElementList) => {
        if (el.name === element.name) {
          el.metadata_element_list.forEach((field: MetadataElement) => {
            if (field.field_id === element.field_id) {
              if (
                field.values &&
                Array.isArray(field.values) &&
                field.values.length > 0
              ) {
                field.values[rowIndex || 0] = {
                  id: value ? 'Y' : 'N', // Assuming 'Y' for checked and 'N' for unchecked
                  display_value: value ? 'Y' : 'N'
                };
              }
              if (field.value && typeof field.value === 'object') {
                field.value = {
                  id: value ? 'Y' : 'N',
                  display_value: value ? 'Y' : 'N'
                };
              }
            }
          });
        }
        return el;
      }
    );
    updateReduxStore(updatedPayload);
  };

  // Get the selected value from Redux state
  let selectedValue: any = null; // Initialize selectedValue
  if (element?.values?.length ?? 0 > 1) {
    selectedValue = singleUploadPayload?.metadata_collection?.metadata_element_list
      ?.find((el: MetadataElement) => el.name === element.name)
      ?.metadata_element_list.find(
        (el: MetadataElement) => el.field_id === element.field_id
      )?.values[rowIndex as number]?.display_value;
  } else {
    selectedValue = singleUploadPayload?.metadata_collection?.metadata_element_list
      ?.find((el: MetadataElement) => el.name === element.name)
      ?.metadata_element_list.find(
        (el: MetadataElement) => el.field_id === element.field_id
      )?.value?.display_value;
  }
  return (
    <CoreCheckbox
      className="custom-checkbox"
      checked={selectedValue === 'Y' || selectedValue === 'True' }
      onCheckboxChange={(e) => onCheckboxChange(e.detail)}
    />
  );
};

export default CheckboxWrapper;
